import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false
    },
    reducers: {
        setAuthenticated: (state) => {
            state.isAuthenticated = true;
        },
        setLoggedOut: (state) => {
            state.isAuthenticated = false;
        }
    }
})

export const { setAuthenticated, setLoggedOut } = authSlice.actions;
export default authSlice.reducer;